import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { ratingsPrivateInputDriverFactory } from './RatingsInput.private.driver';
import { RatingsInput } from '.';

describe('RatingsInput', () => {
  const createDriver = createRendererWithUniDriver(
    ratingsPrivateInputDriverFactory,
  );

  it('should render', async () => {
    const { driver } = createDriver(<RatingsInput onSelect={() => {}} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should return correct rating', async () => {
    const onSelectSpy = jest.fn();
    const { driver } = createDriver(<RatingsInput onSelect={onSelectSpy} />);
    await driver.clickStarAt(0);

    expect(onSelectSpy).toHaveBeenCalledWith(1);

    await driver.clickStarAt(4);

    expect(onSelectSpy).toHaveBeenCalledWith(5);
  });

  it('should have correct rating value', async () => {
    const value = 3;
    const { driver } = createDriver(
      <RatingsInput onSelect={() => {}} value={value} />,
    );

    expect(await driver.getValue()).toBe(value);
  });

  it('should be disabled', async () => {
    const onSelectSpy = jest.fn();
    const { driver } = createDriver(
      <RatingsInput onSelect={onSelectSpy} disabled />,
    );
    await driver.clickStarAt(0);
    expect(await driver.isDisabled()).toBeTruthy();
    expect(onSelectSpy).not.toHaveBeenCalled();
  });

  it('should show error state', async () => {
    const errorMessage = 'Field is required';
    const { driver } = createDriver(
      <RatingsInput errorMessage={errorMessage} onSelect={() => {}} />,
    );
    expect(await driver.hasError()).toBeTruthy();
    expect(await driver.getErrorMessage()).toBe(errorMessage);
  });

  it('should show labelTop layout by default', async () => {
    const { driver } = createDriver(<RatingsInput onSelect={() => {}} />);
    expect(await driver.getLabelLayout()).toBe('labelTop');
  });

  it('should show labelAside layout', async () => {
    const layout = 'labelAside';
    const { driver } = createDriver(
      <RatingsInput labelLayout={layout} onSelect={() => {}} />,
    );
    expect(await driver.getLabelLayout()).toBe(layout);
  });

  it('should show small size by default', async () => {
    const { driver } = createDriver(<RatingsInput onSelect={() => {}} />);
    expect(await driver.getSize()).toBe('small');
  });

  it('should show large size', async () => {
    const size = 'large';
    const { driver } = createDriver(
      <RatingsInput size={size} onSelect={() => {}} />,
    );
    expect(await driver.getSize()).toBe(size);
  });

  it('should show reaction label', async () => {
    const label = 'Wow';
    const { driver } = createDriver(
      <RatingsInput
        onSelect={() => {}}
        value={1}
        getReactionLabel={() => label}
      />,
    );

    expect(await driver.getReactionLabel()).toBe(label);
  });

  it('should show stars as hovered up to the current hovered star', async () => {
    const { driver } = createDriver(<RatingsInput onSelect={() => {}} />);
    await driver.hoverStarAt(1);
    expect(await driver.getActiveStarCount()).toBe(2);

    await driver.hoverStarAt(4);
    expect(await driver.getActiveStarCount()).toBe(5);
  });
});
